import React from "react";
//#region types
import { SupportTeamMember } from "serviceHooks/useSupportTeamContent";
//#endregion
import cssExports from "theme/styles/main.module.scss";

interface TeamCardProps {
  member: SupportTeamMember;
}

const TeamCard: React.FC<TeamCardProps> = ({ member }) => {
  return (
    <div className={cssExports.teamCard}>
      <div className={cssExports.teamCardImageArea}>
        <div className={cssExports.teamCardImageContainer}>
          {member.imageUrl ? (
            <img src={member.imageUrl} alt={member.name} />
          ) : (
            <div className={cssExports.avatarPlaceholder}>{member.name.charAt(0)}</div>
          )}
        </div>
      </div>
      <div className={cssExports.teamCardInfo}>
        <div className={cssExports.teamCardName}>{member.name}</div>
        <div className={cssExports.teamCardRole}>{member.role}</div>
      </div>
    </div>
  );
};

export default TeamCard;
